/** Phone numbers, for display. */

/**
 * `+919812345678` -> `+91 98123 45678`, for a person reading the row rather than
 * matching it against something. Anything that is not a 10-digit Indian mobile
 * behind `+91` is shown exactly as stored — a display rule has no business
 * guessing at a shape it does not recognise.
 */
export function formatPhoneDisplay(e164) {
  if (!e164) return null
  const m = /^\+91(\d{5})(\d{5})$/.exec(e164)
  return m ? `+91 ${m[1]} ${m[2]}` : e164
}
